import { render, staticRenderFns } from "./UnfreezePolicy.vue?vue&type=template&id=a37e524c&"
import script from "./UnfreezePolicy.vue?vue&type=script&lang=js&"
export * from "./UnfreezePolicy.vue?vue&type=script&lang=js&"
import style0 from "./UnfreezePolicy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports